import { Flex } from "antd";
import React, { useState, useEffect, useMemo } from 'react';
import ZCard from '../../../Card/Index';
import FilledLineChart from '../../../Chart/FilledLineChart';
import { SearchOutlined } from "@ant-design/icons";
import CustomButton from "../../../common/CustomButton";
import CustomInput from "../../../common/CustomInput";
import { useDispatch, useSelector } from "react-redux";
import { getAvailableBalance } from "../../../../api/AvailableBalance";
import dayjs from "dayjs";
import { getSummaryDetails } from "../../../../api/reportDetails";
import { setSummaryData } from "../../../../store/reducers/slices/summary.slice";
import { setTxnEndDate, setTxnStartDate } from "../../../../store/reducers/slices/availableBalance.slice";

const AvailableBalance = () => {
    // State for date fields and data array
    const { selectedAccountId, reportDetails } = useSelector(({ reportDetails }) => reportDetails);
    const { summaryList } = useSelector(({ summary }) => summary);
    const { txnStartDate, txnEndDate } = useSelector(({ availableBalance }) => availableBalance);
    const dispatch = useDispatch();

    console.log("DATES ARE DATES NOT Date>>>", txnStartDate, txnEndDate);
    
    // State for date fields and data array
    const [startDate, setStartDate] = useState(txnStartDate);
    const [endDate, setEndDate] = useState(txnEndDate);
    const [entirePeriod, setEntirePeriod] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchDataOfSummary = (accountId) => {
        let aggregate = accountId !== "all" ? false : true;
        let account_id =
        accountId !== "all" ? accountId : reportDetails?.report?.reportId;
        getSummaryDetails(account_id, aggregate)
        .then((resp) => {
            console.log("resp", resp);
            const transactionDates = resp.find(
            (item) => item.sectionName === "Bank Accounts" && item.setId === 2
            )?.sectionValues;
            let startdate =
            transactionDates?.find((item) => item.key === "Txn Start Date")
                .value &&
            (transactionDates.find((item) => item.key === "Txn Start Date")
                .value ||
                "2020-01-05");
            let enddate =
            transactionDates?.find((item) => item.key === "Txn End Date").value &&
            (transactionDates.find((item) => item.key === "Txn End Date").value ||
                "2020-12-09");
            let formattedStartDate = startdate.includes("/")
            ? startdate.split("/").reverse().join("-")
            : startdate;
            let formattedEndDate = enddate.includes("/")
            ? enddate.split("/").reverse().join("-")
            : enddate;
            console.log("formattedStartDate", formattedStartDate);
            console.log("formattedEndDate", formattedEndDate);

            dispatch(setTxnStartDate(formattedStartDate));
            dispatch(setTxnEndDate(formattedEndDate));


        })
        .catch((error) => {
            // alert(`${error.message}`);
        });
    };


    useEffect(() => {
        console.log("Under UE");
    
        if (selectedAccountId) {
          fetchDataOfSummary(selectedAccountId);
        }
      }, [selectedAccountId, dispatch,  txnStartDate, txnEndDate]);


    // Fetch data from API
    const fetchData = async (selectedAccountId) => {
        try {
            setLoading(true)
            const response = await getAvailableBalance(selectedAccountId, txnStartDate, txnEndDate);
            setEntirePeriod(response?.entirePeriod);
            setLoading(false)
            console.log("RESPONSE AVAILABLE BALANCE", response);

        } catch (error) {
            console.log("ERROR", error);
            setLoading(false)
        }
    }


    const handleStartDateChange = (e) => {
        const selectedDate = e.target.value;
        setStartDate(selectedDate)
        dispatch(setTxnStartDate(startDate));
        // Reset endDate if it’s before the newly selected startDate
        if (endDate && selectedDate > endDate) {
            setEndDate('')
        }
    };

    const handleEndDateChange = (e) => {
        const selectedDate = e.target.value;
        setEndDate(selectedDate)
        dispatch(setTxnEndDate(endDate));
        // Reset startDate if it’s after the newly selected endDate
        if (startDate && selectedDate < startDate) {
            setStartDate('')
        }
    };

    useEffect(() => {
        if (selectedAccountId) fetchData(selectedAccountId);
    }, [selectedAccountId, dispatch, txnStartDate, txnEndDate]);


    return (
        <ZCard loading={loading}>
            <Flex justify="space-between">
                <ZCard.Title>Available balance (₹)</ZCard.Title>
                <div style={{ display: 'flex', gap: "8px" }}>
                    <CustomInput
                        type="date"
                        value={startDate}
                        onChange={handleStartDateChange}
                        size="large"
                        placeholder="Statement From"
                        max={endDate || undefined}
                    />
                    <CustomInput
                        type="date"
                        value={endDate}
                        onChange={handleEndDateChange}
                        size="large"
                        placeholder="Statement To"
                        min={startDate || undefined}
                    />
                    <CustomButton
                        icon={<SearchOutlined />}
                        btnStyle={{ background: "#1677FF", height: "40px" }}
                        titleStyle={{ fontWeight: 400, fontSize: "16px", lineHeight: "24px", color: "#FFFFFF" }}
                        size="large"
                        type="primary"
                        htmlType="button"
                        onClick={fetchData}
                    >
                        Search
                    </CustomButton>
                </div>
            </Flex>
            <FilledLineChart
                dataArray={entirePeriod}
                labelKey="balanceBucket"
                valueKey="availabilityPct"
            />
        </ZCard>
    );
};

export default AvailableBalance;
